module.exports = __webpack_public_path__ + "static/media/user-remove-white.7ccb5336.svg";